<template>
  <v-container class="content-wrapper" fluid>
    <v-row class="mt-0">
      <v-spacer></v-spacer>

      <!-- Filters -->
      <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" style="border-radius: 24px;">
              <v-card-text>
                <v-text-field
                  v-model.trim="hostingInstitution.text"
                  rounded
                  placeholder="Search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Ecosystem Stakeholder Profile:</label>
                <v-autocomplete
                  v-model="hostingInstitution.ecosystem"
                  class="mt-2"
                  :items="ecosystem"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Ecosystem Stakeholder Profile'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Areas of Activities:</label>
                <v-autocomplete
                  v-model="hostingInstitution.areasOfActivities"
                  class="mt-2"
                  :items="areasOfActivities"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Areas of Activities'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-actions class="mt-0 pt-0">
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    @click="clear"
                    outlined
                    block
                    depressed
                    large
                    text
                    class="primary200--text font-weight-bold"
                  >
                    Clear
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    @click="triggerFilters"
                    :disabled="!isHostingValid"
                    block
                    depressed
                    rounded
                    large
                    color="primary200"
                    class="white--text font-weight-bold"
                    data-cy="submit"
                    >Done
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Hosting Institutions -->
      <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
        <v-row class="mb-10 justify-start" v-if="!filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="overviewHostingInstitution(institution)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <v-img contain :src="institution.logoUrl">
                          <template v-slot:placeholder>
                            <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ institution.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <v-row v-if="filtered">
          <MarketplaceHostingInstitutionsFiltered
            :filteredParams="params"
            @changeTab="toggleChangeTab"
          >
          </MarketplaceHostingInstitutionsFiltered>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import base from '@/services/base-service.js';
import MarketplaceHostingInstitutionsFiltered from './MarketplaceHostingInstitutionsFiltered.vue';

export default {
  name: 'BrowseCatalogueHostingInstitutions',
  components: { MarketplaceHostingInstitutionsFiltered },
  mixins: [base],
  data() {
    return {
      hostingInstitution: {
        text: '',
        ecosystem: [],
        areasOfActivities: [],
        institutions: [],
      },
      ecosystem: [],
      areasOfActivities: [],
      institutions: [],
      filtered: false,
      params: {},
      queries: {},
      hasDefinedParams: {},
    };
  },
  created() {
    this.queries = this.$route.query;
    if (this.queries) {
      const paramsQueries = {
        text: this.queries.text,
        disabled: false,
        ecosystemStakeholders: this.queries.ecosystemStakeholders,
        areasOfActivity: this.queries.areasOfActivity,
      };

      this.hasDefinedParams = Object.values(paramsQueries).some(value => value !== undefined);

      if (this.hasDefinedParams) {
        console.log('params', paramsQueries);
        this.filtered = true;
        this.params = paramsQueries;
      }
    }
  },
  mounted() {
    this.getEcosystemStakeholderProfile().then(res => {
      this.ecosystem = res.data.content;
    });

    this.getAreasOfActivities().then(res => {
      this.areasOfActivities = res.data.content;
    });

    this.axios.get('/api/v1/hosting-institutions/all').then(res => {
      this.institutions = res.data;
    });
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.filters === 'true' && query.marketplaceInstitutionViewAll) {
          const { ...filterParams } = query;
          if (Object.keys(filterParams).length > 0) {
            this.filtered = true;
            this.params = filterParams;
            if (filterParams.text) {
              this.hostingInstitution.text = filterParams.text;
            }
            if (filterParams.areasOfActivity) {
              this.hostingInstitution.areasOfActivities = filterParams.areasOfActivity
                .split(',')
                .map(Number);
            }
            if (filterParams.ecosystemStakeholders) {
              this.hostingInstitution.ecosystem = filterParams.ecosystemStakeholders
                .split(',')
                .map(Number);
            }
          }
        }
      },
    },
  },
  computed: {
    isHostingValid() {
      const hostingFields = [
        this.hostingInstitution.text,
        ...this.hostingInstitution.ecosystem,
        ...this.hostingInstitution.areasOfActivities,
      ];

      return hostingFields.some(field => field);
    },
  },
  methods: {
    toggleChangeTab() {
      this.clear();
    },
    clear() {
      this.hostingInstitution.text = '';
      this.hostingInstitution.ecosystem = [];
      this.hostingInstitution.areasOfActivities = [];
      this.filtered = false;
      if (this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/marketplace/hosting-institutions',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Hosting Institutions',
          },
        });
      } else if (!this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/public-catalogue-marketplace/hosting-institutions',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Hosting Institutions',
          },
        });
      }
    },
    triggerFilters() {
      const areasOfActivities = this.hostingInstitution.areasOfActivities.map(activity => activity);
      const ecosystemIds = this.hostingInstitution.ecosystem.map(ecosystem => ecosystem);

      const areasOfActivitiesParams = areasOfActivities.join(',');
      const ecosystemParams = ecosystemIds.join(',');

      const params = {
        text: this.hostingInstitution.text,
        areasOfActivity: areasOfActivitiesParams,
        ecosystemStakeholders: ecosystemParams,
        disabled: false,
      };

      this.deleteEmptyProperties(params);
      this.filtered = true;
      this.params = params;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    overviewHostingInstitution(institution) {
      if (this.$store.getters.roles != null) {
        this.$router.push({
          name: 'OverviewHostingInstitution',
          params: { id: institution.id },
        });
      } else {
        this.$router.push({
          name: 'PublicOverviewHostingInstitution',
          params: { id: institution.id },
        });
      }
    },
  },
};
</script>
